var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.mobile)?_c('SupportingImage',{staticClass:"image",attrs:{"sectionKey":_vm.sectionKey}}):_vm._e(),_c('Content',{staticClass:"content",attrs:{"sectionKey":_vm.sectionKey},on:{"changeSection":_vm.handleChangeSection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }